export const adminAdmissionMenu = {
	top: [
		{
			id: "admin-dashboard",
			title: "Dashboard",
			icon: "icon-ico-dashboard",
			path: "/",
			submenu: [],
		},
		{
			id: "admin-pendaftaran-data-pasien",
			title: "Pendaftaran Data Pasien",
			icon: "icon-ico-dashboard",
			path: "/pendaftaran-pasien",
			submenu: [],
		},
		{
			id: "admin-appointments",
			title: "Appointments",
			icon: "icon-ico-dashboard",
			path: "/admission/appointment/list",
			submenu: [],
		},
		{
			id: "admin-checkin-patients",
			title: "Check-in Pasien",
			icon: "icon-ico-dashboard",
			path: "/admission/checkin-patients/list",
			submenu: [],
		},
		{
			id: "admin-kasir",
			title: "Kasir",
			icon: "icon-ico-dashboard",
			path: "/admission/kasir/list",
			submenu: [],
		},
		{
			id: "admin-review",
			title: "Review",
			icon: "icon-ico-star-half",
			path: "/admission/review/list",
			submenu: [],
		},
		{
			id: "absensi-staff",
			title: "Absensi Staff",
			icon: "icon-ico-dashboard",
			path: "/absensi-staff",
			submenu: [],
		},
	],
	bottom: [],
};
